import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  gridItem: {
    display: 'flex',
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
